// extracted by mini-css-extract-plugin
export default {"dropdown_items_wrapper":"PortalSideBar_dropdown_items_wrapper__-r37D","show":"PortalSideBar_show__4LgoY"};